import React, { useState, useEffect } from "react";
import "./BhaktaParivar.scss";
import { MdCall } from "react-icons/md";
import { FaHome } from "react-icons/fa";
import successGif from "../../assets/images/namastehands.jpg";
import dattamaharaj from "../../assets/images/dattamaharaj.jpg";
import { bhaktaParivarEntry, getDistrictdropdownList } from "services/apiservice";
import ReactSelect from "react-select";
import toast from "react-hot-toast";
import MarathiInput from "components/Input/MarathiInput";
import ModalBox from "components/modal/ModalBox";


export default function BhaktaParivar() {
    const [allDistricts, setAllDistricts] = useState([]);
    const [formData, setFormData] = useState({
        name: "",
        emailid: "",
        mobile: "",
        state: "महाराष्ट्र",
        district: "",
        city: "",
        address: "",
        refferalname: "",
    });

    const [errors, setErrors] = useState({});
    const [successModal, setSuccessModal] = useState(false); // ✅ replaces showPopup
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = async (e) => {
        const { name, value } = e.target;
        if (name === "name") {
            const translated = await transliterateToMarathi(value);
            setFormData({ ...formData, [name]: translated });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        let newErrors = {};
        if (!formData.name) newErrors.name = "कृपया आपले नाव भरा";
        if (!formData.mobile) newErrors.mobile = "कृपया मोबाईल क्रमांक भरा";
        if (!formData.state) newErrors.state = "कृपया राज्य निवडा";
        if (!formData.district) newErrors.district = "कृपया जिल्हा निवडा";
        if (!formData.city) newErrors.city = "कृपया शहर भरा";
        if (!formData.address) newErrors.address = "कृपया पत्ता भरा";

        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) return;

        setIsLoading(true);
        try {
            let res = await bhaktaParivarEntry(formData);
            console.log("res", res);

            if (res.code === 200) {
                toast.success(res.message);
                setSuccessModal(true);
                setFormData({
                    name: "",
                    emailid: "",
                    mobile: "",
                    state: "महाराष्ट्र",
                    district: "",
                    city: "",
                    address: "",
                    refferalname: ""
                });
            } else {
                toast.error(res.message || "काहीतरी चूक झाली आहे");
            }
        } catch (err) {
            toast.error("सर्व्हरशी संपर्क होत नाही. कृपया पुन्हा प्रयत्न करा.");
            console.error("Error submitting:", err);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchAllDistricts = async () => {
        if (formData.state !== "महाराष्ट्र") {
            setAllDistricts([]);
            return;
        }

        try {
            const res = await getDistrictdropdownList({ stateId: formData.state });
            if (res.code === 200) {
                setAllDistricts(res.data?.districts?.rows?.rows || []);
            } else {
                toast.error(res.message);
            }
        } catch (err) {
            toast.error(err?.response?.data?.message || err.message);
        }
    };

    useEffect(() => {
        fetchAllDistricts();
    }, [formData.state]);

    const customSelectStyles1 = (hasError) => ({
        control: (base, state) => ({
            ...base,
            backgroundColor: "#fdfbf8",
            borderColor: hasError
                ? "#DC4C64"
                : state.isFocused
                    ? "#fc8c03"
                    : "#ddd",
            borderRadius: "8px",
            padding: "0px 7px",
            boxShadow: state.isFocused
                ? "0 0 6px rgba(252, 140, 3, 0.3)"
                : "none",
            "&:hover": {
                borderColor: "#a16207",
            },
            border: errors.state ? "1px solid #DC4C64" : "1px solid #ccc",
            width: "100%",
        }),
    });
    const customSelectStyles2 = (hasError) => ({
        control: (base, state) => ({
            ...base,
            backgroundColor: "#fdfbf8",
            borderColor: hasError
                ? "#DC4C64"
                : state.isFocused
                    ? "#fc8c03"
                    : "#ddd",
            borderRadius: "8px",
            padding: "0px 7px",
            boxShadow: state.isFocused
                ? "0 0 6px rgba(252, 140, 3, 0.3)"
                : "none",
            "&:hover": {
                borderColor: "#a16207",
            },
            border: errors.district ? "1px solid #DC4C64" : "1px solid #ccc",
            width: "100%",
        }),
    });

    const transliterateToMarathi = async (text) => {
        const res = await fetch(
            `https://inputtools.google.com/request?text=${encodeURIComponent(
                text
            )}&itc=mr-t-i0-und&num=1&cp=0&cs=1&ie=utf-8&oe=utf-8`
        );
        const data = await res.json();
        if (data[0] === "SUCCESS") {
            return data[1][0][1][0];
        }
        return text;
    };

    return (
        <div className="bhakta-parivar-form">
            <div className="container">
                {/* ---------------- Left Side ---------------- */}
                <div className="left-container">
                    <div className="title-container">
                        <label>भक्त परिवारात सामील व्हा</label>
                        <h2>आपल्या भक्तिमय कुटुंबाचा भाग बना !</h2>
                    </div>

                    <div className="address-box">
                        <div className="address-header">
                            <MdCall className="address-icon" />
                            <span className="label">मोबाइल :</span>
                        </div>
                        <div className="desc">+91 9422070407</div>
                    </div>

                    <div className="address-box">
                        <div className="address-header">
                            <FaHome className="address-icon" />
                            <span className="label">पत्ता :</span>
                        </div>
                        <div className="desc">श्री दत्त मंदिर संस्थान, रुईभर</div>
                    </div>
                </div>

                {/* ---------------- Right Side ---------------- */}
                <div className="right-container">
                    <div className="title-container2">
                        <div className="datta_image">
                            <img src={dattamaharaj} alt="Datta Maharaj" />
                        </div>
                        <label className="contact-sub-text">आता सामील व्हा</label>
                        <h2>खालील फॉर्म भरा</h2>
                    </div>

                    {/* ✅ Form */}
                    <form onSubmit={handleSubmit} className="form-container">
                        {/* नाव */}
                        <div className="form-input-container">
                            <MarathiInput
                                value={formData.name}
                                onChange={(val) => {
                                    setFormData({ ...formData, name: val });
                                    if (errors.name && val.trim()) setErrors({ ...errors, name: "" });
                                }}
                                placeholder="नाव"
                                hasError={!!errors.name}
                            />
                            {errors.name && <span className="error-message">{errors.name}</span>}
                        </div>

                        {/* मोबाईल */}
                        <div className="form-input-container">
                            <input
                                type="text"
                                name="mobile"
                                placeholder="मोबाईल"
                                value={formData.mobile}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (/^\d*$/.test(val) && val.length <= 10) {
                                        handleChange(e);
                                        if (errors.mobile && val.trim()) setErrors({ ...errors, mobile: "" });
                                    }
                                }}
                                maxLength={10}
                                style={errors.mobile ? { border: "1px solid #DC4C64" } : undefined}
                            />
                            {errors.mobile && <span className="error-message">{errors.mobile}</span>}
                        </div>

                        {/* राज्य */}
                        <div className="form-input-container">
                            <ReactSelect
                                name="state"
                                placeholder="राज्य निवडा"
                                options={[{ value: "महाराष्ट्र", label: "महाराष्ट्र" }]}
                                value={
                                    formData.state
                                        ? { value: formData.state, label: formData.state }
                                        : null
                                }
                                onChange={(selectedOption) => {
                                    const value = selectedOption?.value || "";
                                    setFormData({ ...formData, state: value, district: "" });
                                    if (errors.state && value.trim()) setErrors({ ...errors, state: "" });
                                }}
                                styles={customSelectStyles1(errors.state)}
                            />
                            {errors.state && <span className="error-message">{errors.state}</span>}
                        </div>

                        {/* जिल्हा */}
                        <div className="form-input-container">
                            <ReactSelect
                                name="district"
                                placeholder="जिल्हा निवडा"
                                options={
                                    allDistricts?.length > 0
                                        ? allDistricts.map(({ id, districtname }) => ({
                                            value: id,
                                            label: districtname,
                                        }))
                                        : []
                                }
                                value={
                                    formData.district
                                        ? {
                                            value: formData.district,
                                            label:
                                                allDistricts.find((d) => d.id === formData.district)?.districtname ||
                                                "जिल्हा निवडा",
                                        }
                                        : null
                                }
                                onChange={(selectedOption) => {
                                    const value = selectedOption?.value || "";
                                    setFormData({ ...formData, district: value });
                                    if (errors.district && value) setErrors({ ...errors, district: "" });
                                }}
                                styles={customSelectStyles2(errors.district)}
                            />
                            {errors.district && (
                                <span className="error-message">{errors.district}</span>
                            )}
                        </div>

                        {/* शहर */}
                        <div className="form-input-container">
                            <MarathiInput
                                value={formData.city}
                                onChange={(val) => {
                                    setFormData({ ...formData, city: val });
                                    if (errors.city && val.trim()) setErrors({ ...errors, city: "" });
                                }}
                                placeholder="शहर"
                                hasError={!!errors.city}
                            />
                            {errors.city && <span className="error-message">{errors.city}</span>}
                        </div>

                        {/* पत्ता */}
                        <div className="form-input-container">
                            <MarathiInput
                                value={formData.address}
                                onChange={(val) => {
                                    setFormData({ ...formData, address: val });
                                    if (errors.address && val.trim()) setErrors({ ...errors, address: "" });
                                }}
                                placeholder="पत्ता"
                                hasError={!!errors.address}
                            />
                            {errors.address && (
                                <span className="error-message">{errors.address}</span>
                            )}
                        </div>
                        {/* पत्ता */}
                        <div className="form-input-container">
                            <MarathiInput
                                value={formData.refferalname}
                                onChange={(val) => {
                                    setFormData({ ...formData, refferalname: val });
                                    // if (errors.refferalname && val.trim()) setErrors({ ...errors, refferalname: "" });
                                }}
                                placeholder="कुटुंब प्रमुखाचे नाव/ संदर्भित व्यक्ती लिहा"
                                // hasError={!!errors.refferalname}
                            />
                            {/* {errors.refferalname && (
                                <span className="error-message">{errors.refferalname}</span>
                            )} */}
                        </div>

                        {/* Submit Button */}
                        <div className="submit-btn">
                            <button type="submit" disabled={isLoading}>
                                {isLoading ? "सबमिट करत आहे..." : "आता सामील व्हा"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            <ModalBox
                status={successModal}
                onClose={() => setSuccessModal(false)}
                title={"नोंद पूर्ण झाली"}
                description={
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: "center",
                            height: "250px", // 🔹 gives enough vertical space for true centering
                        }}
                    >
                        <img
                            src={successGif}
                            alt="Success"
                            style={{
                                width: "200px",
                                height: "200px",
                                objectFit: "contain",
                                marginBottom: "15px",
                                display: "block",
                            }}
                        />
                        <p
                            style={{
                                fontSize: "20px",
                                fontWeight: "600",
                                color: "#5a2801",
                            }}
                        >
                            भक्त परिवारात सामील झाल्याबद्दल धन्यवाद!
                        </p>
                    </div>
                }
                size="sm"
                autoClose={true}
            />



        </div>
    );
}
